import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AudioPlayerProvider } from "@/components/AudioPlayerProvider";
import { BottomAudioPlayer } from "@/components/BottomAudioPlayer";
import { useAudioPlayer } from "@/components/AudioPlayerProvider";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useState } from "react";
import { BeatDetailsModal } from "@/components/BeatDetailsModal";
import Index from "./pages/Index";
import AllBeats from "./pages/AllBeats";
import PaymentSuccess from "./pages/PaymentSuccess";
import ResetPassword from "./pages/ResetPassword";
import NotFound from "./pages/NotFound";
import Logo from "./pages/Logo";

const queryClient = new QueryClient();

const AppContent = () => {
  const { currentBeat, isPlaying, togglePlayPause, closeBeat, playNext, playPrevious } = useAudioPlayer();
  const [selectedBeat, setSelectedBeat] = useState<any>(null);
  const [showBeatDetailsModal, setShowBeatDetailsModal] = useState(false);

  const handleBeatClick = (beat: any) => {
    setSelectedBeat(beat);
    setShowBeatDetailsModal(true);
  };

  return (
    <>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/beats" element={<AllBeats />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/logo" element={<Logo />} />
        <Route path="/logo.png" element={<Logo />} />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      <BottomAudioPlayer
        currentBeat={currentBeat}
        isPlaying={isPlaying}
        onPlayPause={togglePlayPause}
        onClose={closeBeat}
        onNext={playNext}
        onPrevious={playPrevious}
        onBeatClick={handleBeatClick}
      />
      <BeatDetailsModal
        beat={selectedBeat}
        isOpen={showBeatDetailsModal}
        onClose={() => setShowBeatDetailsModal(false)}
      />
    </>
  );
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <AudioPlayerProvider>
          <AppContent />
        </AudioPlayerProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
